/**
 * Created by mac on 1/2/21
 */

const SpeedUpWindow = CleverappsWindow.extend({
    onWindowLoaded: function (worker) {
        this.worker = worker;

        const boostTimeMission = cleverapps.missionManager.findByType(Mission.TYPE_BOOSTTIME);
        if (boostTimeMission && MissionManager.hasProperLocation(boostTimeMission.type)) {
            this.boostTimeMission = boostTimeMission;
        }

        this.controls = this.boostTimeMission ? "MenuBarCoinsItem" : "MenuBarGoldItem";

        this._super({
            title: Messages.get("SpeedUpWindow.title"),
            name: "SpeedUpWindow",
            content: this.createContent(),
            closeButton: this.boostTimeMission === undefined
        });

        cleverapps.focusManager.showControlsWhileFocused(this.controls);

        if (this.worker.getTimeLeft() <= 0) {
            this.close();
        }
    },

    getPerson: function () {
        return {
            role: "worker",
            skin: cleverapps.skins.getSlot("bonusWorkerPersonSkin")
        };
    },

    listBundles: function () {
        return ["speedup_window"];
    },

    createContent: function () {
        const styles = cleverapps.styles.SpeedUpWindow;
        const items = [];

        if (this.boostTimeMission) {
            items.push(this.createTimer());
            items.push(this.createTitle());
            items.push(this.createCoinsButtons());
        } else if (this.worker.isSpeedUpBonusActive()) {
            const willFinish = this.worker.getTimeLeft() <= cleverapps.parseInterval(Workers.SPEEDUP_BONUS_TIME);
            items.push(willFinish && this.createTitle());
            items.push(this.createTimer());
            items.push(this.createAdsButtons(willFinish));
        } else {
            items.push(this.createTitle());
            items.push(this.createTimer());
            items.push(this.createRubyButton(cleverapps.styles.UI.Button.Images.button_blue));
        }

        return new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createTitle: function () {
        const styles = cleverapps.styles.SpeedUpWindow;

        const msg = this.boostTimeMission ? "SpeedUpWindow.coinsText" : "SpeedUpWindow.text";
        const font = this.boostTimeMission ? cleverapps.styles.FONTS.WINDOW_TEXT : cleverapps.styles.FONTS.SPEEDUP_WINDOW_TEXT;
        const text = cleverapps.UI.generateOnlyText(Messages.get(msg), font);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.textWidth, 0);
        text.fitTo(undefined, styles.textHeight);
        return text;
    },

    createRubyButton: function (type, speedUp) {
        const styles = cleverapps.styles.SpeedUpWindow.buttons;

        return new UseGoldButton({
            price: Unit.CalcSpeedUPPrice(this.worker.getTimeLeft()),
            source: this.worker.unit,
            onClicked: this.speedUpForGold.bind(this),
            freeIcon: TextWithIcon.ICONS_BY_NAME.speedup,
            canCoins: true,
            eventName: cleverapps.EVENTS.SPENT.SPEED_UP,
            type,
            width: styles.button.width,
            height: styles.button.height,
            speedUp
        });
    },

    createCoinsButtons: function () {
        const styles = cleverapps.styles.SpeedUpWindow.buttons;

        const rubyButton = this.createRubyButton(undefined, true);

        const nothanksButton = new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            text: Messages.get("SpeedUpWindow.nothanks"),
            onClicked: this.close.bind(this),
            type: cleverapps.styles.UI.Button.Images.button_blue
        });

        return new cleverapps.Layout([rubyButton, nothanksButton], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.coinsMargin,
            padding: styles.padding
        });
    },

    createAdsButtons: function (willFinish) {
        const styles = cleverapps.styles.SpeedUpWindow.buttons;

        const rubyButton = this.createRubyButton(cleverapps.styles.UI.Button.Images.button_blue);

        let rubyTitle;

        if (!willFinish) {
            rubyTitle = cleverapps.UI.generateOnlyText(Messages.get("SpeedUpWindow.rubyHint"), cleverapps.styles.FONTS.SPEEDUP_WINDOW_HINT_TEXT);
            rubyTitle.setString(cleverapps.splitHalfByWord(rubyTitle.getString()).join("\n"));
            rubyTitle.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        }

        const rubyLayout = new cleverapps.Layout([rubyTitle, rubyButton], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.button.margin
        });
        rubyLayout.setAnchorPoint(0.5, 0);

        const watchButton = new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            text: `##${Messages.get("Watch")}`,
            onClicked: this.speedUpForVideo.bind(this),
            type: cleverapps.styles.UI.Button.Images.button_blue
        });

        let watchTitle;

        if (!willFinish) {
            watchTitle = cleverapps.UI.generateOnlyText(Messages.get("SpeedUpWindow.watchHint"), cleverapps.styles.FONTS.SPEEDUP_WINDOW_HINT_TEXT);
            watchTitle.setString(cleverapps.splitHalfByWord(watchTitle.getString()).join("\n"));
            watchTitle.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        }

        const watchLayout = new cleverapps.Layout([watchTitle, watchButton], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.button.margin
        });
        watchLayout.setAnchorPoint(0.5, 0);

        const separator = cleverapps.UI.generateOnlyText(Messages.get("or"), cleverapps.styles.FONTS.SPEEDUP_WINDOW_HINT_TEXT);
        separator.setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER);
        separator.setFixedHeight(true);
        separator.setDimensions(separator.width, watchButton.height);
        separator.setAnchorPoint(0.5, 0);

        return new cleverapps.Layout([rubyLayout, separator, watchLayout], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin,
            padding: styles.padding
        });
    },

    createTimer: function () {
        const styles = cleverapps.styles.SpeedUpWindow.timer;

        let timeLeft = this.worker.getTimeLeft();
        if (timeLeft > 0) {
            timeLeft = new cleverapps.CountDown(timeLeft, {
                onFinish: this.close.bind(this)
            });
        } else {
            timeLeft = 0;
        }

        const timer = new cleverapps.CountDownView(timeLeft, {
            font: cleverapps.styles.FONTS.SPEEDUP_WINDOW_TIMER_TEXT,
            bar: {
                type: ScaledProgressBar.Types.blue_large_with_frames,
                width: styles.width,
                height: styles.height,
                fullValue: this.worker.getFullJobTime()
            },
            icon: {
                json: bundles.big_timer.jsons.big_timer_json,
                animation: "animation"
            }
        });

        if (this.isStopAvailable()) {
            const stopButton = new cleverapps.UI.Button({
                width: styles.button.width,
                height: styles.button.height,
                content: new cc.Sprite(bundles.buttons_main.frames.stop_icon),
                onClicked: this.stopWorker.bind(this),
                type: cleverapps.styles.UI.Button.Images.button_red
            });

            return new cleverapps.Layout([timer, stopButton], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.margin
            });
        }

        return timer;
    },

    speedUpForGold: function () {
        this.close();

        cleverapps.focusManager.display({
            focus: "dospeedup",
            control: this.controls,
            stack: true,
            actions: [
                (f) => cleverapps.timeouts.setTimeout(f, 300),

                (f) => {
                    this.worker.speedUp();
                    f();
                }
            ]
        });
    },

    speedUpForVideo: function () {
        this.close();
        this.worker.speedUpForVideo();
    },

    stopWorker: function () {
        this.close();

        this.worker.completeAssignment();
    },

    isStopAvailable: function () {
        return this.worker.unit && this.worker.unit.findComponent(Buildable) !== undefined;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SPEEDUP_WINDOW_TEXT: {
        size: 70,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    SPEEDUP_WINDOW_TIMER_TEXT: {
        size: 70,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR
    },

    SPEEDUP_WINDOW_HINT_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.SpeedUpWindow = {
    margin: 40,
    textWidth: 1100,
    textHeight: 135,

    timer: {
        width: 490,
        height: 90,
        margin: 20,

        button: {
            x: { align: "right", dx: 125 },
            y: { align: "center", dy: 0 },
            width: 120,
            height: 120
        }
    },

    buttons: {
        margin: 60,
        coinsMargin: 120,
        padding: {
            x: 0,
            y: 0,
            top: 15,
            bottom: 0
        },

        button: {
            width: 340,
            height: 110
        },

        note: {
            margin: 10
        }
    }
};
